var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#D42620"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.177 36.098L47.1902 36.8553C47.2191 38.5119 45.8996 39.8783 44.243 39.9072L42.9296 39.9301C41.5793 39.9537 40.3797 39.0721 39.9989 37.7764L39.9676 37.6699C39.6625 36.6318 38.8236 35.8251 37.7524 35.6725C37.2187 35.5965 36.6453 35.5391 36.1657 35.5475C35.686 35.5559 35.115 35.6333 34.5843 35.7278C33.5191 35.9177 32.7088 36.7532 32.4401 37.8013L32.4126 37.9088C32.0772 39.217 30.9092 40.1399 29.5589 40.1635L28.2454 40.1864C26.5888 40.2153 25.2224 38.8958 25.1935 37.2392L25.1803 36.482C25.1664 35.6865 25.4734 34.9174 26.1445 34.4901C27.5788 33.5768 30.68 32.1427 36.1046 32.048C41.5292 31.9533 44.6786 33.2783 46.1438 34.141C46.8295 34.5446 47.1631 35.3025 47.177 36.098Z",
    fill: "#F9FAFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallAction);
export default __webpack_public_path__ + "static/media/call-action.1f83ebf5504fe91e70e860d8c9dafd38.svg";
export { ForwardRef as ReactComponent };